import {Maybe} from '@coolcolduk/typescript-util';
import {DocumentData, DocumentSnapshot, QueryDocumentSnapshot} from 'firebase/firestore';
import {WithId} from '../../types/WithId';

/**
 * Get the object type from the firestore object
 * - return null if not found
 * - extract id and append to data
 * @param firestoreObject
 * @returns
 * @deprecated move to @coolcolduk/ui-firebase
 */
export default function mapFirestoreDocToObjectType<
  AppModelType = DocumentData,
  DbModelType extends DocumentData = DocumentData,
>(
  firestoreObject?:
    | DocumentSnapshot<AppModelType, DbModelType>
    | QueryDocumentSnapshot<AppModelType, DbModelType>
    | null,
): Maybe<WithId<AppModelType>> {
  if (!firestoreObject) return null;
  const {id} = firestoreObject;
  const data = firestoreObject.data();
  if (!data) {
    return null;
  }
  return {...data, id};
}
